import { isProductionBuild } from '@/utils/environment'

const PHONE_LOCAL_LENGTH = 10
const PHONE_EXTENSION_LENGTH = 4
export const PHONE_MAX_DIGITS = PHONE_LOCAL_LENGTH + PHONE_EXTENSION_LENGTH
const PHONE_PLACEHOLDER = '*'

export const getPhoneEntryMaxDigits = (): number =>
  isProductionBuild ? PHONE_LOCAL_LENGTH : PHONE_MAX_DIGITS

export const formatPhoneNumberInput = (digits: string, maxDigits = PHONE_MAX_DIGITS): string => {
  if (!digits) return ''

  const clamped = digits.slice(0, maxDigits)
  const local = clamped.slice(0, PHONE_LOCAL_LENGTH).padEnd(PHONE_LOCAL_LENGTH, PHONE_PLACEHOLDER)
  const extension = clamped.slice(PHONE_LOCAL_LENGTH)

  const formattedLocal = `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`
  return extension ? `${formattedLocal} ${extension}` : formattedLocal
}

export const stripPhoneCountryCode = (digits: string): string =>
  digits.length === PHONE_LOCAL_LENGTH + 1 && digits.startsWith('1') ? digits.slice(1) : digits

export const formatPhoneNumberDisplay = (rawValue: string | number | null | undefined): string => {
  const digits = String(rawValue ?? '').replace(/\D/g, '')
  if (!digits) return ''

  return formatPhoneNumberInput(stripPhoneCountryCode(digits))
}

export const getTelHref = (rawValue: string | number) =>
  `tel:${String(rawValue).replace(/[^\d+]/g, '')}`
